export default __webpack_public_path__ + "static/media/ISEO CLASS-1 EXAM PATTERN 2026-27.83067389.pdf";